module.exports = __webpack_public_path__ + "media/luxury-2026/modern-dining-960-7ab4008c.jpg";